import {
  Button, Card, CardContent, CardHeader, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Accordion,
  AccordionDetails, AccordionSummary, List, ListItem, ListItemAvatar, ListItemText, Paper, Table, TableBody,
  TableCell, TableContainer, TableRow, Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, openBlob } from 'src/utils/Common';
import { loadUrunControlDetail } from 'src/utils/storage/StartWorkOrder';
import Alert from '@material-ui/lab/Alert';
import logger from 'src/utils/logger';

const useStyles = makeStyles(() => ({

}));

function HelperControl({ className }) {
  const classes = useStyles();
  const [YardimciDataControl, setYardimciDataControl] = useState([]);
  const [YardimciDataLibraryControl, setYardimciDataLibraryControl] = useState([]);
  const [YardimciDataLibraryDetailControl, setYardimciDataLibraryDetailControl] = useState([]);
  const [LoadingControl, setLoadingControl] = useState(true);
  const [expandedControl, setExpandedControl] = useState(false);
  const [openControl, setOpenControl] = React.useState(false);
  const [UyariControl, setUyariControl] = React.useState("");

  const SessionUser = getUser();
  let YardimciDataDegerControl = loadUrunControlDetail();



  var KulModelKodu = YardimciDataDegerControl.length > 0 ? YardimciDataDegerControl[0]?.KUL_MODEL_KODU : '';
  useEffect(() => {
    let mounted = true;
    const fetchLogs = () => {
      axios.get('/GetArtemisTechnicianHelper/' + (KulModelKodu || '-1')).then(response => {
        if (mounted) {
          const Deger = response.data === "" ? [] : response.data;
          setYardimciDataControl(Deger);

        }
      }).catch(error => {
        setLoadingControl(false);
              logger.error("Hata detayı:", error.message);
      });

      if (!KulModelKodu) {
        setYardimciDataLibraryControl([]);
        setLoadingControl(false);
        return;
      }


      axios.get('/GetArtemisLibrary/' + KulModelKodu).then(response => {
        if (mounted) {
          const DegerLibraryControl = response.data === "" ? [] : response.data;
          setYardimciDataLibraryControl(DegerLibraryControl);
          setLoadingControl(false);
        }
      }).catch(error => {
        setLoadingControl(false);
              logger.error("Hata detayı:", error.message);
      });
    }
    fetchLogs();
    return () => {
      mounted = false;
    };
  }, [KulModelKodu]);

  const GetLibraryDetailControl = (panel) => {
    setLoadingControl(true);
    axios.get('/GetArtemisDetailLibrary/' + KulModelKodu + '/' + panel).then(response => {
      const Deger = response.data === "" ? [] : response.data;
      setYardimciDataLibraryDetailControl(Deger);
      setLoadingControl(false);
    }).catch(error => {
      setLoadingControl(false);
            logger.error("Hata detayı:", error.message);
    });
  };

  const DetayAcControl = (log) => {
    setLoadingControl(true);
    const data = {
      BIRIM_KODU: SessionUser.ServiceShopId.toString(),
      SICIL_NO: SessionUser.UserId,
      FilePtr: log.FP,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/ArtemisBulten', data, config)
      .then(response => {
        openBlob(response.data, log.BK + '_' + log.BN);
        setLoadingControl(false);
      }).catch(error => {
        setUyariControl("Bülten açılamadı!..3");
        setOpenControl(true);
        setLoadingControl(false);
              logger.error("Hata detayı:", error.message);
      });
  };

  const handleChangeControl = (panel) => (event, isExpanded) => {
    setExpandedControl(isExpanded ? panel : false);
    if (isExpanded === true) {
      GetLibraryDetailControl(panel);
    }

  };

  const handleOpenTHelperControl = (event, Link) => {
    event.persist();
    window.open(Link);
    event.persist();
  };




  const user = getUser();
  let user_types = user.TechnicianType.split(",");
  let klima_teknisyeni = false;
  user_types && user_types.forEach(u => {
    if (parseInt(u.TIP) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return <Card>
      <CardHeader title="Yetki Kontrolü" />
      <Divider />
      <CardContent className={classes.contentMin}>
        Yetkiniz bulunmadığı için sayfa görüntülenemiyor!..
      </CardContent>
    </Card>;
  }

  const handleCloseControl = () => {
    setOpenControl(false);
  };


  return (
    <div>
      <Dialog
        open={openControl}
        onClose={handleCloseControl}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {UyariControl}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseControl} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {window.navigator.onLine ?
        <div className={clsx(classes.root, className)}>
          <Card>
            <CardHeader title="Ürün Kütüphanesi" />
            <Divider />
            {
              LoadingControl ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {YardimciDataControl.map(log => (
                  <div key={log.ACIKLAMA}>
                    <ListItem alignItems="flex-start"
                      onClick={(event) => handleOpenTHelperControl(event, log.LINK)}
                    >
                      <ListItemAvatar>
                        <div>
                          <Typography
                            component="span"
                            variant="h6"
                            className={classes.inline}
                            color="textPrimary">
                            {log.HIZMET_ACIKLAMA}
                          </Typography>
                        </div>
                      </ListItemAvatar>
                      <ListItemText
                        primary={log.ACIKLAMA}
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </div>
                ))}
              </List>
            </CardContent>
          </Card>
          <Card className={classes.contentMin}>
            <CardHeader title="E-Kütüphane" />
            {YardimciDataLibraryControl.map(log => (
              <Accordion key={log.ACIKLAMA} expanded={expandedControl === log.BANKATIPI} onChange={handleChangeControl(log.BANKATIPI)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>{log.ADET} Adet</Typography>
                  <Typography className={classes.secondaryHeading}>{log.ACIKLAMA}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        {YardimciDataLibraryDetailControl.map(row => (
                          <TableRow
                            key={row.A}
                          >
                            <TableCell component="th"
                              onClick={() => DetayAcControl(row)}
                              scope="row">
                              {row.A}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )
            )}
          </Card>
        </div>
        :
        <Card className={clsx(classes.root, className)}>
          <CardHeader title="Teknisyen Yardımcısı" />
          <CardContent className={classes.contentMin}>
            <Alert severity="info">Offline oldugunuz için görüntüme yapılamıyor lütfen online moda geçtikten sonra tekrar deneyiniz!...</Alert>
          </CardContent>
        </Card>
      }
    </div>
  );
}

HelperControl.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(HelperControl);
